import { Typography, type TypographyProps, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = Omit<TypographyProps, "children"> & {
	lines: ReadonlyArray<string>;
};

export const TextLineList: FC<Props> = ({
	lines,
	variant = "caption",
	color,
	noWrap = true,
	...typographyProps
}) => {
	const { palette } = useTheme();

	return (
		<>
			{lines.map((line) => (
				<Typography
					key={line}
					variant={variant}
					color={color ?? palette.grey[500]}
					noWrap={noWrap}
					{...typographyProps}
				>
					{line}
				</Typography>
			))}
		</>
	);
};
